var map = {
	"./animated-icon/animated-icon.vue": 9462,
	"./btn/btn.vue": 4385,
	"./core/accessibility.vue": 4902,
	"./core/index.vue": 7649,
	"./core/transition-height.vue": 9285,
	"./gift-with-purchase/gift-with-purchase.vue": 3502,
	"./images/art-direction.vue": 3974,
	"./images/responsive-image.vue": 7712,
	"./market-switcher/market-switcher.vue": 7888,
	"./newsletter-modal/newsletter-modal.vue": 5645,
	"./nosto/nosto.vue": 2159,
	"./overlay/overlay.vue": 6965,
	"./product-prices/product-prices.vue": 4229,
	"./site-header/pre-header-banner.vue": 3504,
	"./site-header/site-header.vue": 6386
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7489;